import React from 'react';
import * as classes from './Color.module.css';

const Color = (props) =>{
    const styles = props.classes? [classes.Color, ...props.classes] : [classes.Color];

    return(
        <div
            className={styles.join(' ')}
            style={{backgroundColor: `#${props.color}`}}
        ></div>
    )
};

export default Color;